import { put, call, takeLatest } from "redux-saga/effects";
import { fetchDowntimeFilter } from "Services/api/downtime";

/********** ACTION_TYPES **********/
export const actionTypes = {
  fetchData: "downtimeFilter/INITIATE_FETCH_DATA",
  fetchDataFailed: "downtimeFilter/FETCH_DATA_FAILED",
  fetchDataFulfilled: "downtimeFilter/FETCH_DATA_FULFILLED",
};

/********** REDUCER **********/
const initialState = {
  fetching: false,
  fetched: false,
  data: [],
  errMsg: null,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.fetchData: {
      return {
        ...state,
        fetching: true,
      };
    }
    case actionTypes.fetchDataFailed: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        errMsg: action.payload,
      };
    }
    case actionTypes.fetchDataFulfilled: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        data: action.payload.data,
        errMsg: null,
      };
    }
    default: {
      return state;
    }
  }
};

/********** SELECTORS **********/
export const selectors = {
  getDowntimeFilter: (state) => state.downtimeFilter || [],
  isFetching: (state) => state.downtimeFilter?.fetching,
  isFetched: (state) => state?.downtimeFilter?.fetched,
  getErrorMsg: (state) => state.downtimeFilter?.errMsg,
};

/********** ACTION_CREATORS **********/
export const actions = {
  fetchData: (data) => ({
    type: actionTypes.fetchData,
    payload: data,
  }),
  fetchDataFailed: (data) => ({
    type: actionTypes.fetchDataFailed,
    payload: data,
  }),
  fetchDataFulfilled: (data, infiniteLoading) => ({
    type: actionTypes.fetchDataFulfilled,
    payload: { data, infiniteLoading },
  }),
};

/********** WORKERS **********/
function* fetchDataWorker(data) {
  try {
    const params = {};
    const response = yield call(fetchDowntimeFilter, params);

    if (response.status == 200) {
      yield put(actions.fetchDataFulfilled(response?.data?.result));
    }
  } catch (err) {
    const errMsg = yield err?.response?.data?.error || "Something went wrong";
    yield put(actions.fetchDataFailed(errMsg));
  }
}

/********** SAGAS **********/
export function* saga() {
  yield takeLatest(actionTypes.fetchData, fetchDataWorker);
}
